var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-table__row-group"},[_c(_setup.LinhaDeItemResumo,{attrs:{"dado":_setup.props?.dado,"item":_setup.props?.item},on:{"update:alteraItem":_setup.alteraItem}}),_c(_setup.LinhaDeItemDetalhes,{attrs:{"dado":_setup.props?.dado,"item":_setup.props?.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }